// Инициализация адаптеров для веб-приложения
import { ApiClient } from '@alveon/shared/api/client';
import { Config } from '@alveon/shared/config';
import { webStorage, webNetwork, webTelegram } from './index';
import { initializePowerSync, getPowerSync, isPowerSyncReady, disconnectPowerSync } from './powersync';
import { logger } from '../utils/logger';
import i18n from '../i18n/config';

// Конфигурация API клиента (VITE_API_URL для dev override, иначе production)
const API_BASE_URL = import.meta.env.VITE_API_URL || Config.API_BASE_URL;

logger.info('API Base URL:', API_BASE_URL);

const apiConfig = {
  apiBaseUrl: API_BASE_URL,
  isDevelopment: import.meta.env.DEV || window.location.hostname === 'localhost',
  onSessionExpired: (message: string) => {
    logger.info('Session expired:', message);
    
    // Очищаем токен и перезагружаем страницу только один раз
    // чтобы приложение показало экран логина
    const alreadyHandled = sessionStorage.getItem('session_expired_handled');
    if (!alreadyHandled) {
      sessionStorage.setItem('session_expired_handled', 'true');
      
      // Переводим сообщение через i18n
      let translatedMessage = message;
      if (message === 'Session expired') {
        translatedMessage = i18n.t('auth.sessionExpired', 'Сессия истекла');
      } else if (message === 'Password was changed') {
        translatedMessage = i18n.t('auth.passwordChanged', 'Пароль был изменен');
      } else if (message === 'Session revoked or expired') {
        translatedMessage = i18n.t('auth.sessionRevoked', 'Сессия отозвана или истекла');
      }
      
      // Показываем сообщение и перезагружаем
      alert(translatedMessage);
      
      // Очищаем токен перед перезагрузкой
      localStorage.removeItem('auth_token');
      
      // Перезагружаем страницу
      window.location.reload();
    }
  },
  onError: (message: string) => {
    logger.error(message);
  }
};

// Создаем экземпляр API клиента с адаптерами
export const apiClient = new ApiClient(
  apiConfig,
  webStorage,
  webNetwork,
  webTelegram
);

// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// 🔄 PowerSync инициализация
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
/**
 * Запускает PowerSync ПОСЛЕ авторизации пользователя.
 */
export async function startPowerSync(): Promise<void> {
  try {
    const token = localStorage.getItem('auth_token');
    if (!token) {
      logger.debug('[PowerSync] No auth token, skipping initialization');
      return;
    }

    await initializePowerSync(
      async () => localStorage.getItem('auth_token'),
      API_BASE_URL,
      apiClient
    );
  } catch (error) {
    logger.warn('[PowerSync] Start failed (non-critical):', error);
  }
}

// Экспортируем для использования в приложении
export { getPowerSync, isPowerSyncReady, disconnectPowerSync };
